import { useEffect } from 'react';

interface SeoJsonLdProps {
  type: 'WebSite' | 'Organization' | 'WebPage' | 'FAQPage' | 'SoftwareApplication';
  data: Record<string, any>;
}

const SeoJsonLd = ({ type, data }: SeoJsonLdProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `jsonld-${type.toLowerCase()}`;
    
    const jsonLdData = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data
    };
    
    script.text = JSON.stringify(jsonLdData);
    
    // Remove existing script if present
    const existingScript = document.getElementById(`jsonld-${type.toLowerCase()}`);
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById(`jsonld-${type.toLowerCase()}`);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data]);
  
  return null;
};

export default SeoJsonLd;
